import { TaskCompletionStateFragment } from "gql/graphql";

type Completion = TaskCompletionStateFragment["completion"];

export type RecurringCompletion = Extract<
  Completion,
  { __typename: "RecurringCompletionDto" }
>;

export type OneTimeCompletion = Extract<
  Completion,
  { __typename: "OneTimeCompletionDto" }
>;

/**
 * Повторяемая задача: вместо срока у неё расписание, а выполняются её итерации.
 * Сужает `completion` до расписания, чтобы дальше не разбирать союз руками.
 */
export function isRecurringTask<T extends TaskCompletionStateFragment>(
  task: T,
): task is T & { completion: RecurringCompletion } {
  return task.completion.__typename === "RecurringCompletionDto";
}
